// Copyright (c) Move Closer 2022.

import gql from 'graphql-tag'

import { MagentoVersion, QueryRegistry, QueryRegistryFactory } from '../../../contexts'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const stockQueries: QueryRegistryFactory = (config) => {
  const version = config.byKey<MagentoVersion>('magentoVersion', false) ?? MagentoVersion.Default
  let queries: QueryRegistry = {
    productsSalableQtyBySkuArray: {
      type: 'query',
      query: gql`
          query($productsSku: [String]) {
              productsSalableQtyBySkuArray(productsSku: $productsSku) {
                  salable_qty
                  sku
              }
          }
      `,
      meta: {}
    }
  }

  if (version === MagentoVersion.Ver24) {
    queries = {
      ...queries,
      subscribeToStock: {
        type: 'mutation',
        query: gql`
          mutation (
            $input: SubscribeStockInput!
          ) {
            SubscribeStock (
              input: $input
            )
          }
        `,
        meta: {}
      }
    }
  }

  return queries
}
